import proyecto from "../../api/Proyecto";
import { getSelectedCajaId } from "../../helpers/cajaSelection";

export const getReparaciones = async () => {
  const res = await proyecto.get("/reparaciones");
  return res.data;
};

export const cambiarEstado = async (
  id_reparacion,
  nuevoEstado,
  observaciones = "",
  costo = null,
  fecha_entrega = null
) => {
  const res = await proyecto.put(`/reparaciones/estado/${id_reparacion}`, {
    nuevoEstado,
    observaciones,
    costo,
    fecha_entrega,
    id_caja: getSelectedCajaId(),
    metodo_pago: "EFECTIVO",
  });
  return res.data;
};

export const cambiarEstadoConPago = async (
  id_reparacion,
  nuevoEstado,
  { observaciones = "", costo = null, fecha_entrega = null, metodo_pago = "EFECTIVO", id_caja } = {}
) => {
  const res = await proyecto.put(`/reparaciones/estado/${id_reparacion}`, {
    nuevoEstado,
    observaciones,
    costo,
    fecha_entrega,
    metodo_pago,
    id_caja: id_caja ?? getSelectedCajaId(),
  });
  return res.data;
};

export const getHistorial = async (id_reparacion) => {
  const res = await proyecto.get(`/reparaciones/historial/${id_reparacion}`);
  return res.data;
};

